<template>
  <div class="left">
    <div class="t">
      <div class="tit">数据监控</div>
      <div class="ul">
        <div class="li">
          <img src="./components/1.png" alt="">
          <div class="text">
            <div class="num">20</div>
            <div class="name">安全运行天数</div>
          </div>
        </div>
        <div class="li">
          <img src="./components/6.png" alt="">
          <div class="text">
            <div class="num">668</div>
            <div class="name">设备总数</div>
          </div>
        </div>
        <div class="li">
          <img src="./components/9.png" alt="">
          <div class="text">
            <div class="num">18</div>
            <div class="name">站点数量</div>
          </div>
        </div>
        <div class="li">
          <img src="./components/3.png" alt="">
          <div class="text">
            <div class="num">215 </div>
            <div class="name">监测点总数</div>
          </div>
        </div>
      </div>
    </div>
    <div class="t" style="margin-bottom: 0;">
      <div class="tit">设备信息</div>
      <div class="ul">
        <div class="li">
          <img src="./components/7.png" alt="">
          <div class="text">
            <div class="num">3680</div>
            <div class="name">实时负荷</div>
          </div>
        </div>
        <div class="li">
          <img src="./components/10.png" alt="">
          <div class="text">
            <div class="num">2856</div>
            <div class="name">最大负荷数</div>
          </div>
        </div>
        <div class="li">
          <img src="./components/4.png" alt="">
          <div class="text">
            <div class="num">24</div>
            <div class="name">配电房数量</div>
          </div>
        </div>
        <div class="li">
          <img src="./components/2.png" alt="">
          <div class="text">
            <div class="num">216</div>
            <div class="name">负荷设备数</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import webMap from "@/page/webMap/webMap.vue";
  export default {
    components: {
      webMap
    },
    data () {
      return {
        nowScale: 50, //当前缩放倍率
        token: '', //token
        ids: [],
        svgPath: '',
      }
    },

    mounted () {

    },
    destroyed () {

    },
    methods: {

    }
  }
</script>

<style lang="scss" scoped>
  .left {
    .t {
      background-color: #fff;
      padding-left: 12px;
      margin-bottom: 12px;
      overflow: hidden;
      border-radius: 4px;
      padding-bottom: 20px;
    }
  }

  .tit {
    height: 18px;
    font-family: Microsoft YaHei;
    font-size: 14px;
    font-weight: bold;
    color: #1A1A1A;
    margin-top: 12px;
    margin-bottom: 20px;
  }

  .ul {
    display: flex;

    .li {
      flex: 1;
      border-radius: 4px;
      /* 自动布局 */
      display: flex;
      flex-direction: row;
      align-items: center;
      padding: 12px;
      gap: 12px;
      background: #F7F9FA;
      margin-right: 12px;

      .num {
        /* 自动布局子元素 */
        width: 23px;
        height: 23px;
        font-family: Arial;
        font-size: 20px;
        font-weight: bold;
        font-variation-settings: "opsz" auto;
        color: #1A1A1A;
      }

      .name {
        /* 自动布局子元素 */
        height: 17px;
        opacity: 1;

        font-family: Microsoft YaHei;
        font-size: 13px;
        font-weight: normal;

        font-variation-settings: "opsz" auto;
        color: #666;
      }
    }
  }
</style>